"use strict";exports.headingSizes=["xs","sm","md","lg","xl","2xl","3xl","4xl"];
//# sourceMappingURL=heading.types-b6ca7d59.js.map
